// @flow
import React from 'react'
import Helmet from 'react-helmet'

const PrivacyPolicy = () => (
  <div style={{ padding: '4rem 0' }}>
    <Helmet title="Privacy Policy" />
    <div className="container">
      <p>
        By visiting kiefrealty.com or making use of the Kief Realty Applications
        (together, the &ldquo;Sites&rdquo;), you are accepting the practices
        outlined in this Privacy Policy and our Terms of Use. Some terms used in
        this Privacy Policy are defined in our Terms of Use. A term used only
        here is &ldquo;cookie.&rdquo; A cookie is a small electronic file
        containing a string of characters that is sent to your computer when you
        visit a website. When you visit the website again, the cookie allows
        that site to recognize your computer. Cookies may store user preferences
        and other information. You can reset your browser to refuse all cookies
        or to indicate when a cookie is being sent. However, some website
        features may not function properly without cookies.
      </p>
      <h5>1. Information Collection, Use, and Opting Out</h5>
      <p>
        The types of information we collect depend on your level of engagement
        with the Sites. The higher the level, the more information we need to
        provide our services.
      </p>
      <u>
        A. All Kief Realty Website and Users of the Kief Realty Applications
      </u>
      <p>
        From registered and unregistered users of the Sites, we automatically
        receive and record information whenever you interact with the Sites.
        This includes IP address data from our server logs, cookie information,
        the pages you request, and the URL of the site you came to the Sites
        from. From all Users of the Kief Realty Applications (&ldquo;App
        Users&rdquo;) we also collect the mobile device ID and your geo-location
        information so that we can interact with you; we need to know where to
        direct responsive Application pages and it allows us to provide geo
        specific information, such as homes for sale near you. Your IP address
        serves the same function for website Users. App Users can turn off our
        access to your geo-location by adjusting &ldquo;location services&rdquo;
        within your iOS or Android device settings. We use the information
        listed above to help diagnose Site problems and performance, analyze
        trends, customize your experience on the Sites, and administer the
        Sites.
      </p>
      <p>Cookies and opting out:</p>
      <ul>
        <li>
          <u style={{ marginRight: '4px' }}>Kief Realty Cookies:</u>
          <span>
            We put Kief Realty cookies on your computer to help us keep track of
            when you were last on the Sites, and what you last searched on the
            Sites. While you are free to disable cookies on your browser, we
            recommend that you leave cookies activated to use some of the most
            useful Kief Realty features.
          </span>
        </li>
        <li>
          <u style={{ marginRight: '4px' }}>
            Third-Party Cookies for Website Use Analysis:
          </u>
          <span>
            We use third parties such as Google and comScore to help us analyze
            how people are using the Sites. We also use the Google Analytics
            Advertising service to provide us with demographic data about our
            users on an anonymous basis, and that Google service uses a cookie
            that can be recognized by Google or its affiliate DoubleClick when
            you visit other websites.
          </span>
        </li>
        <li>
          <u style={{ marginRight: '4px' }}>
            Third-Party Cookies Used to Target Ads to You When You are on Other
            Websites:
          </u>
          <span>
            The Google Doubleclick cookie will inform Google that you visited
            the Sites. Google may serve Kief Realty ads to you on other websites
            on our behalf. Similarly, the Sites drop cookies on your browser
            that are read when you visit Facebook, so that during your visits to
            the Facebook website you might receive Kief Realty advertising based
            on the pages you visited on the Sites. We may work with other
            companies and use their cookies to target Kief Realty ads to you on
            other websites.
          </span>
        </li>
        <li>
          <u style={{ marginRight: '4px' }}>Opting Out of Google Analytics:</u>
          <span>
            To prevent your data from being used by Google Analytics,{' '}
            <a href="https://tools.google.com/dlpage/gaoptout/">click here</a>{' '}
            for instructions.
          </span>
        </li>
        <li>
          <u style={{ marginRight: '4px' }}>
            Opting Out of Google Advertising:
          </u>
          <span>
            To opt out of Google interest-based advertising,{' '}
            <a href="https://www.google.com/settings/u/0/ads/authenticated?hl=en">
              click here
            </a>{' '}
            to see your Google ad settings.
          </span>
        </li>
        <li>
          <u style={{ marginRight: '4px' }}>Opting Out Generally:</u>
          <span>
            The Self-Regulatory Program for Online Behavioral Advertising
            program provides consumers with the ability to opt-out of having
            their online behavior recorded and used for advertising purposes. To
            opt-out of having your online behavior collected for advertising
            purposes (for example, serving Kief Realty ads to you on Facebook),{' '}
            <a href="http://www.aboutads.info/choices/#completed">click here</a>{' '}
            for instructions. Choices you make are both browser and
            device-specific. This means that, for example, if you opt out when
            using Safari on your phone, you will not be opted out on Firefox or
            on your laptop.
          </span>
        </li>
        <li>
          <u style={{ marginRight: '4px' }}>Do Not Track:</u>
          <span>
            Some browsers have a &ldquo;do not track&ldquo; feature that lets
            you tell websites that you do not want to have your online
            activities tracked. These features are not yet uniform, so we are
            not currently set up to respond to those signals.
          </span>
        </li>
        <li>
          <u style={{ marginRight: '4px' }}>Flash Cookies:</u>
          <span>
            We currently do not use flash cookies, but we may in the future. To
            control flash cookies,{' '}
            <a href="http://www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager.html">
              click here
            </a>
            . Why? Because flash cookies do not reside in your browser, so your
            browser settings will not affect them.
          </span>
        </li>
      </ul>
      <u>
        B. Registered Kief Realty Site Users (including Registered App Users)
      </u>
      <p>
        We obtain your name and email address in exchange for full user account
        access, as well as access to the full MLS listings data. You give us
        this information when you create your Kief Realty account. When you give
        us this information at one of our events, or upon request, we will
        create a Kief Realty account for you and this Privacy Policy and our
        Terms of Use apply. In addition, when you are signed in to your Kief
        Realty account and using Kief Realty through Facebook, Twitter, or any
        other third-party authorization service, we may make use of the data
        that they provide us to further customize your Kief Realty experience.
      </p>
      <ul>
        <li>
          <u style={{ marginRight: '4px' }}>My Kief Realty:</u>
          <span>
            My Kief Realty is a feature that allows you to save searches, add
            favorites and otherwise organize homes that may be of interest to
            you. We save all of this &ldquo;My Kief Realty&rdquo; information
            for your use later. It is stored with your Kief Realty account
            information.
          </span>
        </li>
        <li>
          <u style={{ marginRight: '4px' }}>Account Password Security:</u>
          <span>
            Your Kief Realty account password is secure within our platform.
          </span>
        </li>
        <li>
          <u style={{ marginRight: '4px' }}>Account Updates:</u>
          <span>
            By visiting your My Kief Realty: Account Settings, you can correct,
            amend, add or delete personal information associated with your
            account. However, even after you update information, we may maintain
            a copy of the original information in our records.
          </span>
        </li>
      </ul>
      <u>C. Home Tours</u>
      <p>
        When you submit a home tour request, we will ask for your tour date and
        time preferences, as well as your phone number. We will also ask some
        questions so that our agent can verify your identity. When you meet up
        with one of our agents at the home, the agent will ask you to verify
        your identity, and may even ask for a photo ID. At this point, your
        relationship with Kief Realty is not just online.
      </p>
      <u>D. Kief Realty Clients</u>
      <p>
        When you are getting ready to buy or sell a home and you start working
        with our coordinators and agents, you become a Kief Realty Client. As
        part of the home purchase or sale process, you will need to provide a
        lot of information as is customary for a home purchase or sale
        transaction. This information can include, without limitation, your
        name, address, phone number, email address, buyer loan pre-approval
        documentation and seller property information. We ask you, as a buyer,
        for loan pre-approvals from a mortgage broker or lender to determine
        which homes are in your price range, and to help you make an offer more
        quickly when you do find a home. You, as a seller, are legally required
        to disclose certain information about your property to prospective
        buyers. Once you sign a Listing Agreement or Buyer Agreement with us,
        your relationship with Kief Realty is governed by that agreement, as
        well as our online Terms of Use and this Privacy Policy.
      </p>
      <h5>2. Information Storage</h5>
      <p>We store all User information on secure servers and in the cloud.</p>
      <h5>3. Information Sharing</h5>
      <p>
        We share your information with Kief Realty personnel in the normal
        course of business. We also share some of your information with third
        parties.
      </p>
      <u>A. Registered Site Users (including Registered App Users):</u>
      <p>
        We share your information with our third party partners who support and
        promote our Sites. Under our contracts with them, they are not allowed
        to use your information for any purpose other than supporting and
        promoting our Sites. If you follow a link on our Sites to a third party
        site, its privacy policy governs the collection and use of information
        you provide on that site.
      </p>
      <u>B. Kief Realty Clients:</u>
      <ul>
        <li>
          <u style={{ marginRight: '4px' }}>Public Record Information:</u>
          <span>
            Please be aware that home sales and purchases are a matter of public
            record, and your name and address, the price you paid, your property
            taxes, and other information will be available from public sites
            regardless of the brokerage(s), if any, who assist in the
            transaction. We post on our Sites some information that typically
            becomes part of the public record of a home sale or purchase.
          </span>
        </li>
        <li>
          <u style={{ marginRight: '4px' }}>Non-Public Record Information:</u>
          <span>
            We share information obtained from you that is not public record in
            order to facilitate your home purchase or sale transaction.
          </span>
        </li>
        <li>
          <u style={{ marginRight: '4px' }}>
            Service Providers to all Kief Realty Clients:
          </u>
          <span>
            Our agents work with third parties to process your home search and
            sale transaction, and must share your information with those third
            parties. Examples include MLSs and providers of software used for
            document preparation and electronic signing.
          </span>
        </li>
        <li>
          <u style={{ marginRight: '4px' }}>Referral Agents:</u>
          <span>
            A Referral Agent is employed by or works with another brokerage, but
            has teamed up with us to provide Kief Realty-quality service to a
            wider range of customers. We may refer you to a Referral Agent at
            our discretion. If you are referred to a Referral Agent for your
            home purchase or sale transaction, we share your information with
            that Referral Agent so they can assist you.
          </span>
        </li>
        <li>
          <u style={{ marginRight: '4px' }}>Home Seller Service Providers:</u>
          <span>
            As is customary as your home sales agent, we share your listing
            information with MLSs and other listing websites, such as Trulia.com
            and Zillow.com. We also share your listing information with listing
            vendors such as photographers, home staging experts and home repair
            professionals like plumbers and electricians, as needed.
          </span>
        </li>
        <li>
          <u style={{ marginRight: '4px' }}>Home Buyer Service Providers:</u>
          <span>
            As is customary as your home purchase agent, we must share your
            buying information with inspectors, title companies, escrow agents,
            closing attorneys, lenders, and other third parties as needed to
            process your transaction.
          </span>
        </li>
        <li>
          <u style={{ marginRight: '4px' }}>Potential Buyers:</u>
          <span>
            By law, we are required to disclose to potential buyers certain
            information you provide about your property.
          </span>
        </li>
        <li>
          <u style={{ marginRight: '4px' }}>Negotiations:</u>
          <span>
            We may post on our Sites price offers and counteroffers. We do not
            post your name on our Sites without your permission but if the sale
            is closed, the price and the fact that you bought or sold your house
            at that price is a matter of public record.
          </span>
        </li>
      </ul>
      <h5>4. Information Deletion</h5>
      <p>
        You may request deletion of your Kief Realty account by e-mailing us at
        info@kiefrealty.com. We may keep a copy for our records.
      </p>
      <h5>5. Email Communications</h5>
      <p>
        We communicate with account holders and Clients about their accounts and
        home tours, searches and sales by email. You may also subscribe to
        Listing Alert Emails with customized summaries of homes for sale. If you
        opt-in to also receive marketing email messages, Kief Realty may send
        you Kief Realty-related news, surveys or promotions. If you do not want
        to receive alerts or marketing email from us, follow the opt-out
        instructions contained in the unwanted email message. If you want to
        stop receiving all email from us, request deletion of your account.
      </p>
      <h5>6. Changes to this Privacy Policy</h5>
      <p>
        Kief Realty reserves the right to change this policy at any time. Please
        check this page periodically for changes. Your continued use of the
        Services following the posting of changes to this policy will mean you
        accept those changes. If we make any material changes to this Privacy
        Policy, we will post the updated Privacy Policy here and may notify you
        by email or by means of a notice on our website.
      </p>
      <p>This Privacy Policy is effective January 1, 2017.</p>
      <h5>7. Children</h5>
      <p>
        The Sites are meant for adults. We do not knowingly collect personally
        identifiable information from children under 13 without permission from
        a parent or guardian. If you are a parent or legal guardian and think
        your child under 13 has given us information, you can email us or write
        us at the mailing address shown below. Please mark your inquiries
        &ldquo;COPPA Information Request.&rdquo;
      </p>
      <h5>8. Contact Us</h5>
      <p>
        Please contact us if you have more questions. If you have any questions
        about this policy, please email us at info@kiefrealty.com. You can also
        write to us at: 311 West Oak Street, Paxton IL 60957.
      </p>
    </div>
  </div>
)

export default PrivacyPolicy



// WEBPACK FOOTER //
// ./src/views/PrivacyPolicy/index.js